/**
 * Layout del sito pubblico (home, medici, contatti, blog, ecc.).
 * Mantiene il sito separato dall'area autenticata (admin/medico/paziente).
 * L'assistente virtuale (chat/avatar) non è presente qui: è solo in area pazienti.
 *
 * Google Analytics 4 (G-724398ND8R) è caricato esclusivamente da questo layout:
 *  - lo script gtag.js viene iniettato una sola volta (idempotente);
 *  - send_page_view è disabilitato per evitare che GA4 tracci automaticamente
 *    via History API anche le rotte autenticate (admin/medico/paziente);
 *  - i page_view vengono sparati manualmente solo ai cambi di rotta DENTRO
 *    questo layout, così l'area riservata resta fuori da analytics.
 */
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../components/public/Header';
import Footer from '../components/public/Footer';
import CookieYesLoader from '../components/public/CookieYesLoader';
import '../styles/vc-design-tokens.css';
import '../styles/LegalPages.css';
import '../styles/public-cwv.css';
import './PublicLayout.css';

const GA_MEASUREMENT_ID = 'G-724398ND8R';

function ensureGaLoaded() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (/ReactSnap/i.test(navigator.userAgent || '')) return;
  if (window.__vcGaInitialized) return;
  window.__vcGaInitialized = true;

  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.setAttribute('data-vc-analytics', 'ga4');
  document.head.appendChild(script);
}

const PublicLayout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    ensureGaLoaded();
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: typeof document !== 'undefined' ? document.title : undefined,
    });
  }, [location.pathname, location.search]);

  return (
    <div className="public-layout vc-restyle-scope">
      <CookieYesLoader />
      <a href="#main-content" className="vc-skip-link">Vai al contenuto principale</a>
      <Header />
      <main id="main-content" tabIndex={-1}>{children}</main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
